import {
    IonButtons,
    IonContent,
    IonHeader,
    IonPage,
    IonToolbar,
    IonBackButton,
    IonLoading,
    IonToast,
    IonTitle,
    IonList,
    IonItem,
    IonLabel,
    IonNote,
    IonTextarea,
    IonFab,
    IonFabButton,
    IonIcon,
    IonFabList,
    IonButton,
    IonAlert,
    IonItemGroup,
    IonItemDivider
} from '@ionic/react';
import React, { useState, useEffect, useContext } from 'react';

import './MealPage.css';
import Firebase, { withFirebase } from '../services/Firebase';
import { useLocation, useParams } from 'react-router';
import { heart, thumbsDown, thumbsUp, statsChart, chatboxEllipses } from 'ionicons/icons';
import { AuthUserContext } from '../services/Session';

interface PageProps {
  firebase: Firebase,
  ownerFlag: boolean,
}

const Page: React.FC<PageProps> = ({ firebase, ownerFlag }) => {
  const location = new URLSearchParams(useLocation().search);
  const { mealId } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error>();
  const [meal, setMeal] = useState({ id: '', userId: '', type: '' });
  const [rate, setRate] = useState({ rate : null });
  const user = useContext(AuthUserContext);
  const [comments, setComments] = useState<any[]>([]);
  const [showCommentModal, setShowCommentModal] = useState(false);
  let loader = ownerFlag ? 1 : 0;

  useEffect(() => {
    if(!user) return;
    const stopLoading = () => {
      loader++;
      if (loader >= (ownerFlag ? 2 : 3)) {
        setLoading(false);
      }
    }
    setLoading(true);
    const unsubscribeMeal = firebase
    .meals()
    .doc(mealId)
    .onSnapshot((doc : any) => {
      const meal = {
        id: doc.id,
        ...doc.data()
      }
      meal.createdAt = meal.createdAt.toDate();
      setMeal(meal)
      stopLoading()
    }, (error: any) => {
      stopLoading()
      setError(error);
    });
    const unsubscribeComments = firebase
    .comments()
    .where('mealId', '==', mealId)
    .where((ownerFlag ? 'ownerId' : 'userId'), '==', user.uid)
    .orderBy('createdAt', 'desc')
    .onSnapshot((querySnapshot) => {
      const comments:any[] = [];
      querySnapshot.forEach((doc) => {
        const comment = {
          id: doc.id,
          ...doc.data()
        };
        comments.push(comment);
      });
      stopLoading()
      setComments(formatList(comments));
    }, error => {
      console.log(error)
      stopLoading()
      setError(error);
    })
    if (ownerFlag) return
    const unsubscribeRate = firebase
    .ratings()
    .doc(`${mealId}.${user.uid}`)
    .onSnapshot((doc : any) => {
      const rate = {
        id: doc.id,
        ...doc.data()
      }
      setRate(rate)
      stopLoading()
    }, (error: any) => {
      stopLoading()
      // setError(error);
    });
    return () => {
      // Nettoyage de l'abonnement
      unsubscribeMeal();
      if(unsubscribeRate) unsubscribeRate();
      unsubscribeComments();
    };
  }, [firebase, mealId, loader, user, ownerFlag]);

  const formatList = (comments: any[]) => {
    const data = comments.reduce((r, e) => {
      let group = e.createdAt.toDate().toLocaleDateString();
      if(!r[group]) r[group] ={ group, children: [e]}
      else r[group].children.push(e);
      return r; 
    }, {});

    return Object.values(data);
  };

  const postMealRate = (rate: number) => {
    if (!user || !meal) return
    setLoading(true);
    const docRef = firebase.ratings().doc(`${meal.id}.${user.uid}`);
    docRef.set({
      mealId: meal.id,
      createdAt: firebase.Timestamp.fromDate(new Date()),
      rate,
      userId: user.uid,
      mealType: meal.type,
      ownerId: meal.userId
    })
    .then (() => {
      setLoading(false);
    })
    .catch(error => {
      setError(error);
      setLoading(false);
    });
  }

  const postMealComment = ({ comment }: any) => {
    if (!user || !meal) return
    setLoading(true);
    setShowCommentModal(false);
    const docRef = firebase.comments().doc();
    docRef.set({
      mealId: meal.id,
      createdAt: firebase.Timestamp.fromDate(new Date()),
      comment,
      userId: user.uid,
      ownerId: meal.userId
    })
    .then (() => {
      setLoading(false);
    })
    .catch(error => {
      setError(error);
      setLoading(false);
    });
  }

  const wmeal = Object.assign({
    type: '',
    photoURL: '/assets/icon/icon.png',
    name: location.get('name'),
    desc: '', 
    createdAt: new Date()
  }, meal)

  let mealType;
  switch (wmeal.type) {
    case 'breakfast':
      mealType = 'Petit Déjeuner'
      break;
    case 'lunch':
      mealType = 'Déjeuner'
      break;
    case 'snack':
      mealType = 'Collation'
      break;
    default:
      mealType = 'Diner'
      break;
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color='primary'>
          <IonButtons>
            <IonBackButton defaultHref='/home' />
          </IonButtons>
            <IonButtons slot='end'>
              {
                ownerFlag
                && <IonButton routerLink={`/home/meals/${mealId}/stats?name=${wmeal.name}`}>
                    <IonIcon icon={statsChart} />
                  </IonButton>
              }
            </IonButtons>
          <IonTitle className="ion-text-uppercase">{wmeal.name}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonLoading isOpen={loading} />
        <IonToast
          isOpen={!!error}
          message={(error || { message: 'Oups, une erreure s\'produite...'}).message}
          duration={8000}
          color="danger"
        />
        <img src={wmeal.photoURL} alt={wmeal.name || ''} className="mealDetailImg"/>
        <IonList>
          <IonItem>
              <IonLabel>Repas</IonLabel>
              <IonNote slot='end'>{mealType}</IonNote>
            </IonItem>
            <IonItem>
              <IonLabel>Date</IonLabel>
              <IonNote slot='end'>{wmeal.createdAt.toLocaleString()}</IonNote>
            </IonItem>
            <IonItem lines='none'>
              <IonLabel position="stacked">Remarques</IonLabel>
              <IonTextarea readonly value={wmeal.desc}></IonTextarea>
            </IonItem>
        </IonList>
        {
          !ownerFlag && <div>
            <IonFab vertical="bottom" horizontal="end" slot="fixed" className="buttonstack_margin-bottom">
              <IonFabButton color="light" onClick={() => {setShowCommentModal(true)}}>
                <IonIcon icon={chatboxEllipses} />
              </IonFabButton>
            </IonFab>
            <IonFab vertical="bottom" horizontal="end" slot="fixed">
              <IonFabButton>
                <IonIcon icon={heart} />
              </IonFabButton>
              <IonFabList side="start">
              <IonFabButton color={rate?.rate === 0 ? 'primary' : 'light'} onClick={() => postMealRate(0)}>
                <IonIcon icon={thumbsDown} />
              </IonFabButton>
              <IonFabButton color={rate?.rate === 1 ? 'primary' : 'light'} onClick={() => postMealRate(1)}>
                <IonIcon icon={thumbsUp} />
              </IonFabButton>
              <IonFabButton color={rate?.rate === 2 ? 'primary' : 'light'} onClick={() => postMealRate(2)}>
                <IonIcon icon={heart} />
              </IonFabButton>
              </IonFabList>
            </IonFab>
            <IonAlert
              isOpen={showCommentModal}
              onDidDismiss={() => setShowCommentModal(false)}
              cssClass='my-custom-class'
              header={'Commentaires'}
              inputs={[
                {
                  name: 'comment',
                  type: 'textarea',
                  placeholder: 'Laissez un commentaire',
                  attributes: {
                    spellcheck: true,
                    rows: 10
                  }
                },
              ]}
              buttons={[
                {
                  text: 'Annuler',
                  role: 'cancel',
                  cssClass: 'secondary',
                },
                {
                  text: 'Envoyer',
                  handler: postMealComment
                }
              ]}
            />
            </div>
        }
        <h6 className='ion-padding'>Commentaires {ownerFlag ? 'reçus' : 'envoyés'}</h6>
        {
          comments.length
          ? <IonList>
            {
              comments.map(({ group, children }) => (
                <IonItemGroup key={group}>
                  <IonItemDivider>
                    <IonLabel color="primary">{group}</IonLabel>
                  </IonItemDivider>
                  { children.map((comment: any) => (
                    <IonItem lines='none' key={comment.id}>
                      <IonNote slot='start'><small>{comment.createdAt.toDate().toLocaleTimeString().substring(0,5)}</small></IonNote>
                      <IonLabel className='ion-text-wrap ion-text-justify'>
                        <IonLabel><h2>{comment.comment}</h2></IonLabel>
                      </IonLabel>
                    </IonItem>
                  ))}
                </IonItemGroup>
              ))
            }
          </IonList>
          : <div className='d-flex ion-padding ion-text-center'>
            <p><IonIcon icon={chatboxEllipses} /></p>
            {
              ownerFlag
              ? <p>Vous n'avez pas de commentaires</p>
              : <p>Vous n'avez laissé de commentaires</p>
            }
          </div>
        }
      </IonContent>
    </IonPage>
  );
};

export default withFirebase(Page);
